import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './NewFinanceUploadFolder.css';

const NEW_FINANCE_ROOT =
  process.env.REACT_APP_NEW_FINANCE_BASE || '/new-finance';

function NewFinanceUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={NEW_FINANCE_ROOT}
      sessionPrefix="new_finance_folder"
    />
  );
}

NewFinanceUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default NewFinanceUploadFolder;
